<header class="container-fluid">
	<ng-container *ngIf="!isPopupWindow">
		<div class="row top-row" [ngClass]="envName">
			<div class="col main-logo" [ngClass]="{ 'pl-0': loading }">
				<a [routerLink]="['/']" *ngIf="!isDirect">
					<pk-broker-loader [show]="loading" color="white"></pk-broker-loader>
					<img
						*ngIf="showBranding && navbarLogoAttachment"
						[attr.src]="environment.baseUrl + '/attachments/' + navbarLogoAttachment.attachmentId + '/view?access_token=' + environment.apiKey" />
				</a>
				<span *ngIf="isDirect">
					<pk-broker-loader [show]="loading" color="white"></pk-broker-loader>
					<img
						*ngIf="showBranding && navbarLogoAttachment"
						[attr.src]="environment.baseUrl + '/attachments/' + navbarLogoAttachment.attachmentId + '/view?access_token=' + environment.apiKey" />
				</span>
			</div>
			<div class="col-auto top-nav" [ngClass]="{ 'navbar-preload': loading }">
				<ul class="float-right">
					@if (canShowDemoEnergyPortal) {
						<li>
							<a href="javascript:void(0)" [routerLink]="['enterprise']">
								<fa-icon [icon]="['far', 'lightbulb-dollar']"></fa-icon>
								<span class="d-none d-md-inline">Energy Portal</span>
							</a>
						</li>
					}
					<ng-container *ngIf="(!loading && !isDirect && user) || isBillReader">
						<ng-container *ngIf="!isDemoEnergyPortal">
							<li *ngIf="showFinancialProfile">
								<a
									class="collapse-link collapsed"
									href="javascript:void(0)"
									(click)="isFinancialProfileCollapsed = !isFinancialProfileCollapsed"
									[attr.aria-expanded]="!isFinancialProfileCollapsed">
									<span><fa-icon [icon]="['fas', 'dollar-sign']"></fa-icon></span>
									<span class="d-none d-md-inline"> Financial Profile</span>
								</a>
							</li>
							<li *ngIf="user && !user.supplierId && !user.enterpriseId && !user.isSaas">
								<ng-container *ngIf="!user.agent || user.agent.isActive">
									<a href="javascript:void(0)" (click)="openFaqSearch()" *ngIf="useSupportSystem">
										<fa-icon [icon]="['fas', 'question']"></fa-icon>
										<span class="d-none d-md-inline"> Support</span>
									</a>
									<a href="mailto:{{ supportEmail }}" *ngIf="!useSupportSystem && supportEmail">
										<fa-icon [icon]="['fas', 'question']"></fa-icon>
										<span class="d-none d-md-inline"> Support</span>
									</a>
								</ng-container>
							</li>
						</ng-container>
						<li>
							<ng-container *ngIf="isBillReader">
								<a [routerLink]="['bill-reader', 'edit']">
									<span><fa-icon [icon]="['fas', 'user']"></fa-icon></span>
									<span class="d-none d-md-inline"> Account</span>
								</a>
							</ng-container>
							<ng-container *ngIf="!isBillReader">
								<a [routerLink]="['security', 'edit']">
									<span><fa-icon [icon]="['fas', 'user']"></fa-icon></span>
									<span class="d-none d-md-inline"> Account</span>
								</a>
							</ng-container>
						</li>
					</ng-container>
					<li *ngIf="!isDirect || isBillReader">
						<a (click)="logout()" href="javascript:void(0)">
							<fa-icon [icon]="['fas', 'sign-out-alt']"></fa-icon>
							<span class="d-none d-md-inline"> Logout</span>
						</a>
					</li>
				</ul>
			</div>
			<div class="col-auto top-nav" *ngIf="!loading && isDirect && user && !user.isNrg">
				<ul class="float-right">
					<li>
						<a [attr.href]="'tel:' + user.phone">
							<fa-icon [icon]="['fas', 'phone']"></fa-icon>
							{{ user.phone | phone }}
						</a>
					</li>
					<br *ngIf="isMobile" />
					<li>
						<a [attr.href]="'mailto:' + user.email">
							<fa-icon [icon]="['fas', 'envelope']"></fa-icon>
							{{ user.email }}
						</a>
					</li>
				</ul>
			</div>
			<div
				*ngIf="!loading && !isDirect && user"
				class="col-12 pl-4 pl-xl-5 pr-4 pb-5 financial-profile"
				[collapse]="isFinancialProfileCollapsed"
				[isAnimated]="true"
				id="freqBroker">
				<pk-broker-navbar-financial-profile
					*ngIf="user && agentDiscountPrograms && user.agent && !user.enterpriseId"
					(toggledFinancialProfileProgram)="toggleFinancialProfileProgram($event)"
					[user]="user"
					[agentDiscountPrograms]="agentDiscountPrograms">
				</pk-broker-navbar-financial-profile>
			</div>
		</div>
		<div class="row bottom-row" [ngClass]="envName" *ngIf="!isDirect && user">
			<div class="d-none d-sm-block col breadcrumb-nav">
				<nav aria-label="breadcrumb">
					<ol class="breadcrumb" *ngIf="!loading">
						<li *ngFor="let breadcrumb of breadcrumbs; let i = index" class="breadcrumb-item" [ngClass]="{ active: i === breadcrumbs.length - 1 }">
							<ng-container *ngIf="i !== breadcrumbs.length - 1">
								<a [routerLink]="breadcrumb.route" [queryParams]="breadcrumb.queryParams" *ngIf="i !== breadcrumbs.length - 1">{{
									breadcrumb.text
								}}</a>
							</ng-container>
							<ng-container *ngIf="i === breadcrumbs.length - 1">
								{{ breadcrumb.text }}
							</ng-container>
						</li>
					</ol>
				</nav>
			</div>
			<div class="col-sm-auto search-nav" *ngIf="!isDemoEnergyPortal">
				<ul class="float-right mb-2" *ngIf="!loading">
					<li class="d-lg-inline pl-0" *ngIf="user && !user.supplierId && !user.enterpriseId && searchForm && (!user.agent || user.agent.isActive)">
						<form id="searchForm" [formGroup]="searchForm" class="form-inline d-inline-block mb-0" (ngSubmit)="onSubmit()">
							<fa-icon class="mr-1" [icon]="['fas', 'search']"></fa-icon>
							<input class="form-control" type="text" placeholder="Search" aria-label="Search" formControlName="search" />
						</form>
					</li>
					<ng-container *ngIf="isMenuCollapsed && user">
						<li class="d-none d-lg-inline" *ngIf="user.showPricingAnalytics && (!user.agent || user.agent.isActive)">
							<a [routerLink]="['/supplier', 'pricing-copilot']">Pricing Copilot</a>
						</li>
						<ng-container *ngIf="!user.supplierId && !user.enterpriseId">
							<li class="d-none d-lg-inline" *ngIf="user.showReports"><a [routerLink]="['/report', 'home']">Reports</a></li>
							<li class="d-none d-lg-inline" *ngIf="user.showReferralExchange && (!user.agent || user.agent.isActive)">
								<a [routerLink]="['/referral-exchange']">Referral Exchange</a>
							</li>
							<li class="d-none d-lg-inline" *ngIf="user.showNewsResources && (!user.agent || user.agent.isActive)">
								<a [routerLink]="['/news']">News &amp; Resources</a>
							</li>
							<li class="d-none d-lg-inline" *ngIf="user.showAdvisorAcademy && (!user.agent || user.agent.isActive)">
								<a [routerLink]="['/academy']">Advisor Academy</a>
							</li>
							<li class="d-none d-lg-inline" *ngIf="!user.agent">
								<a [routerLink]="['/cPanel', 'home']">Setup</a>
							</li>
						</ng-container>
					</ng-container>
					<li class="main-nav-link" *ngIf="showMenu">
						<a
							class="collapse-link collapsed"
							(click)="toggleMenu()"
							href="javascript:void(0)"
							[attr.aria-expanded]="!isMenuCollapsed"
							id="mainNavCollapseLink">
							<span class="collapse-menu-text" *ngIf="isMenuCollapsed">Menu<fa-icon [icon]="['fas', 'bars']"></fa-icon></span>
							<span class="collapse-close-text" *ngIf="!isMenuCollapsed">Close<fa-icon [icon]="['fas', 'times']"></fa-icon></span>
						</a>
					</li>
				</ul>
			</div>
			<div class="col-12 collapse main-nav" [collapse]="isMenuCollapsed" [isAnimated]="true" id="mainNavCollapse" *ngIf="!loading">
				<div class="row py-3">
					<div *ngFor="let menu of user.menus" class="col-12 col-sm-6 col-md-4">
						<p>
							<a *ngIf="!menu.queryString" [routerLink]="menu.eventName" (click)="collapseMenu()" class="mainNavLink" [attr.id]="menu.idName">
								@if ((menu?.className || menu?.iconClassName) && isIconAvailable(menu.className || 'fas', menu.iconClassName)) {
									<fa-icon [icon]="[menu.className ? menu.className : 'fas', menu.iconClassName]"></fa-icon>
								}
								{{ menu.name }}
							</a>
							<a *ngIf="menu.queryString" href="javascript:void(0)" (click)="runMethod(menu.eventName)" class="mainNavLink" [attr.id]="menu.idName">
								@if ((menu?.className || menu?.iconClassName) && isIconAvailable(menu.className || 'fas', menu.iconClassName)) {
									<fa-icon [icon]="[menu.className ? menu.className : 'fas', menu.iconClassName]"></fa-icon>
								}
								{{ menu.name }}
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="isPopupWindow">
		<div class="row top-row">
			<div class="col main-logo" style="min-height: 50px" [ngClass]="{ 'pl-0': loading }">
				<span>
					<pk-broker-loader [show]="loading" color="white"></pk-broker-loader>
					<img
						*ngIf="showBranding"
						[attr.src]="
							environment.baseUrl +
							'/attachments/' +
							(user?.agent?.darkDisplayLogoAttachment?.attachmentId || defaultNavbarLogoAttachment.attachmentId) +
							'/view?access_token=' +
							environment.apiKey
						" />
				</span>
			</div>
		</div>
	</ng-container>
</header>
